import { gotoFirst, setCursors } from "../actions";
import { loadFromLS } from "../../utils";
import { DEFAULT_PAGE_SIZES } from "../../components/KPTable";
import { refreshing } from "../../../kptable";
import { actionConfirmation, actionWaiting, applyFilters, globalActionProgress, globalActionWaiting, resetFilters } from "../../../kptable/actions/actions";
import { objectToParamFilter } from "../../../kptable/utils";
export function extractGetCursedParamsFromState(state, tableId, defaultInitialPageSize) {
    if (state.kpcursedtable[tableId]) {
        const { top, current, currentDirection, filter } = state.kpcursedtable[tableId];
        return {
            top,
            current,
            currentDirection,
            filter: objectToParamFilter(filter),
        };
    }
    else {
        const partialState = loadFromLS(tableId);
        return {
            top: partialState.top || defaultInitialPageSize || DEFAULT_PAGE_SIZES[0],
            current: partialState.current,
            currentDirection: partialState.currentDirection || "next",
        };
    }
}
const callLoaderHelper = async (getState, dispatch, id, silent, loaderFunc) => {
    if (!silent) {
        dispatch(refreshing(id, true));
    }
    try {
        const { next, prev } = await loaderFunc(extractGetCursedParamsFromState(getState(), id));
        dispatch(setCursors(id, next, prev));
    }
    finally {
        if (!silent) {
            dispatch(refreshing(id, false));
        }
    }
};
export const doCursedResetFilters = (id, loaderFunc) => {
    return async (dispatch, getState) => {
        dispatch(resetFilters(id));
        dispatch(gotoFirst(id));
        await callLoaderHelper(getState, dispatch, id, false, loaderFunc);
    };
};
export const doCursedApplyFilters = (id, loaderFunc) => {
    return async (dispatch, getState) => {
        dispatch(applyFilters(id));
        dispatch(gotoFirst(id));
        await callLoaderHelper(getState, dispatch, id, false, loaderFunc);
    };
};
export const doCursedCallLoaderFunc = (id, loaderFunc, silent = false) => {
    return async (dispatch, getState) => {
        await callLoaderHelper(getState, dispatch, id, silent, loaderFunc);
    };
};
export const doCursedExecuteAction = (id, datum, keyField, action, itemValue) => {
    return async (dispatch) => {
        dispatch(actionConfirmation(id, datum, keyField));
        dispatch(actionWaiting(id, datum[keyField], true));
        try {
            await action.handler(datum, itemValue);
        }
        finally {
            dispatch(actionWaiting(id, datum[keyField], false));
        }
    };
};
export const doCursedExecuteGlobalAction = (id, action, data, keyField) => {
    return async (dispatch, getState) => {
        const { checked, globalCheckedAll, filter, top, current, currentDirection } = getState().kpcursedtable[id];
        const filteredData = data.filter((d) => checked[d[keyField]]);
        dispatch(globalActionWaiting(id, true, action.progress));
        try {
            const progressFunction = action.progress
                ? (progress) => {
                    dispatch(globalActionProgress(id, progress));
                }
                : undefined;
            const queryParams = {
                top,
                current,
                currentDirection,
                filter: objectToParamFilter(filter),
            };
            const config = {
                setProgress: progressFunction,
                globalCheckedAll,
                queryParams,
            };
            await action.handler(filteredData, config);
        }
        finally {
            dispatch(globalActionWaiting(id, false));
        }
    };
};
